import { createFeatureSelector, createSelector } from "@ngrx/store";
import { featureKey } from "./app-data-store.reducer";
import { AppState } from "./app-data-store-state";

export const selectAppState = createFeatureSelector<AppState>(featureKey);

export const selectCompanyMode = createSelector(selectAppState, state => state?.companyModeInfo);
export const selectCompanyId = createSelector(selectAppState, state => state?.companyId);
